import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExternalBillingRoutingModule} from './external-billing-routing.module';
import {ExternalUnprocessClaimsComponent} from './external-unprocess-claims/external-unprocess-claims.component';
import {ExternalProcessedClaimsComponent} from './external-processed-claims/external-processed-claims.component';
import {ExternalPaymentsComponent} from './external-payments/external-payments.component';
import {ExternalDenialsAuditsComponent} from './external-denials-audits/external-denials-audits.component';
import {ExternalDenialsComponent} from './external-denials/external-denials.component';

@NgModule({
  imports: [
    CommonModule,
    ExternalBillingRoutingModule
  ],
  declarations: [
    ExternalUnprocessClaimsComponent,
    ExternalProcessedClaimsComponent,
    ExternalPaymentsComponent,
    ExternalDenialsAuditsComponent,
    ExternalDenialsComponent
  ]
})
export class ExternalBillingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/external-billing/external-billing.module.ts